import React from 'react';
import PropTypes from 'prop-types';

import isAre from 'common/util/isAre';

import SrBox from 'client/components/SrBox';
import SrTextGreycliff from 'client/components/SrTextGreycliff';

const getNotRequiredUtilityTypes = ({ utilityTypes = [], utilityActivation }) => {
  const utilityActivationRequiredTypeIds = utilityActivation.requiredTypes.map(
    (item) => item.utilityTypeId,
  );

  return utilityTypes.filter(({ id }) => !utilityActivationRequiredTypeIds.includes(id));
};

function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

const generateBoldText = (utilityTypeLabels) => {
  if (utilityTypeLabels.length === 1) {
    return utilityTypeLabels[0];
  }

  const lastUtilityTypeLabel = utilityTypeLabels.pop();
  return utilityTypeLabels.join(', ') + ' and ' + lastUtilityTypeLabel;
};

const SrUtilitySetupNotRequiredTypes = ({ utilityTypes, utilityActivation }) => {
  const notRequiredTypes = getNotRequiredUtilityTypes({
    utilityTypes,
    utilityActivation,
  });

  if (!notRequiredTypes.length) {
    return null;
  }

  const boldText = capitalize(generateBoldText(notRequiredTypes.map(({ label }) => label)));
  const isAreText = isAre(notRequiredTypes.length);

  return (
    <SrBox textAlign="center" marginTop="18px">
      <SrTextGreycliff weight="700" size="14" lineHeight="20px">
        {boldText}
      </SrTextGreycliff>
      <SrTextGreycliff weight="600" size="14" lineHeight="20px">
        {' '}
        service {isAreText} either part of the rent, billed back to the tenant by the property
        manager, come with other services, or {isAreText}n’t needed.
      </SrTextGreycliff>
    </SrBox>
  );
};

SrUtilitySetupNotRequiredTypes.displayName = 'SrUtilitySetupNotRequiredTypes';

SrUtilitySetupNotRequiredTypes.propTypes = {
  utilityTypes: PropTypes.array,
  utilityActivation: PropTypes.object,
};

export default SrUtilitySetupNotRequiredTypes;
